import React from 'react';
import {observer} from 'mobx-react';
import moment from 'moment';
import {DatePicker} from 'components';
import {FormattedMessage} from 'react-intl';

const HolidayDateForm = observer(({uiState}) => {
  const {currentHoliday, year} = uiState;
  const startDate = moment(`${year}-01-01`).toDate();
  const endDate = moment(`${year}-12-31`).toDate();

  return (
    <div className="clearfix table py1">
      <div className="col-5 table-cell align-middle">
        <FormattedMessage id='time_off.holidays.Date'/>
      </div>
      <div className="col-7 table-cell">
        <div className="clearfix">
          <DatePicker
            value={moment(currentHoliday.date)}
            onChange={value => uiState.handleDateChange(value)}
            options={
              {
                maxViewMode: 'months',
                startDate: startDate,
                endDate: endDate
              }
            }
          />
        </div>
      </div>
    </div>
  );
});

export default HolidayDateForm;
